import { render, staticRenderFns } from "./authentication-check.vue?vue&type=template&id=6ed20d69&scoped=true&"
import script from "./authentication-check.vue?vue&type=script&lang=js&"
export * from "./authentication-check.vue?vue&type=script&lang=js&"
import style0 from "./authentication-check.vue?vue&type=style&index=0&id=6ed20d69&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ed20d69",
  null
  
)

export default component.exports